
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SkillAttainmentSkillExpressionAttainment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SkillAttainment_SkillExpressionAttainment"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attainmentStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"skillExpression"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SkillAttainmentSkillAreaAttainment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SkillAttainment_SkillAreaAttainment"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"areAllExpressionsAttained"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"skillArea"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"skillExpressionsAttainment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SkillAttainmentSkillExpressionAttainment"},"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSkillAttainmentByOccupationGroupAndCareerBand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"careerBand"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifiedSkills_CareerBand"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"occupationGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"VerifiedSkillsAttainment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skillAttainmentByOccupationGroupAndCareerBand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"careerBand"},"value":{"kind":"Variable","name":{"kind":"Name","value":"careerBand"}}},{"kind":"Argument","name":{"kind":"Name","value":"occupationGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"occupationGroupId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SkillAttainmentSkillAreaAttainment"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":771}};
    doc.loc.source = {"body":"fragment SkillAttainmentSkillExpressionAttainment on SkillAttainment_SkillExpressionAttainment {\n  attainmentStatus\n  skillExpression {\n    id\n    name\n  }\n}\n\nfragment SkillAttainmentSkillAreaAttainment on SkillAttainment_SkillAreaAttainment {\n  areAllExpressionsAttained\n  skillArea {\n    id\n    name\n    course {\n      id\n      slug\n      name\n    }\n  }\n  skillExpressionsAttainment {\n    ...SkillAttainmentSkillExpressionAttainment\n  }\n}\n\nquery GetSkillAttainmentByOccupationGroupAndCareerBand(\n  $careerBand: VerifiedSkills_CareerBand!\n  $occupationGroupId: ID!\n) {\n  VerifiedSkillsAttainment {\n    skillAttainmentByOccupationGroupAndCareerBand(careerBand: $careerBand, occupationGroupId: $occupationGroupId) {\n      ...SkillAttainmentSkillAreaAttainment\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SkillAttainmentSkillExpressionAttainment"] = oneQuery(doc, "SkillAttainmentSkillExpressionAttainment");
        
        module.exports["SkillAttainmentSkillAreaAttainment"] = oneQuery(doc, "SkillAttainmentSkillAreaAttainment");
        
        module.exports["GetSkillAttainmentByOccupationGroupAndCareerBand"] = oneQuery(doc, "GetSkillAttainmentByOccupationGroupAndCareerBand");
        
